module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MDAiIGhlaWdodD0iMzAwIj48cGF0aCBmaWxsPSIjMDA5ZTQ5IiBkPSJNMCAwaDUwMHYzMDBIMHoiLz48cGF0aCBkPSJNMCAwbDUwMCAxNTBMMCAzMDB6IiBmaWxsPSIjZmZmIi8+PHBhdGggZD0iTTAgMTMuMDVMNDU2IDE1MCAwIDI4Ni45NXoiIGZpbGw9IiNmY2QxMTYiLz48cGF0aCBkPSJNMCAwbDI1MCAxNTBMMCAzMDB6Ii8+PHBhdGggZD0iTTAgMTcuNUwyMjAuODUgMTUwIDAgMjgyLjV6IiBmaWxsPSIjY2UxMTI2Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/guy.svg
// module id = LcNC
// module chunks = 0